/**
  * bootstrap-table - An extended table to integration with some of the most widely used CSS frameworks. (Supports Bootstrap, Semantic UI, Bulma, Material Design, Foundation)
  *
  * @version v1.24.0
  * @homepage https://bootstrap-table.com
  * @author wenzhixin <wenzhixin2010@gmail.com> (http://wenzhixin.net.cn/)
  * @license MIT
  */

!function (r, n) {
  "object" == typeof exports && "undefined" != typeof module ? n(require("jquery")) : "function" == typeof define && define.amd ? define(["jquery"], n) : n((r = "undefined" != typeof globalThis ? globalThis : r || self).jQuery);
}(this, function (r) {
  "use strict";

  var n,
    t,
    e = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {},
    o = {};
  function u() {
    if (t) return n;
    t = 1;
    var r = function (r) {
      return r && r.Math === Math && r;
    };
    return n = r("object" == typeof globalThis && globalThis) || r("object" == typeof window && window) || r("object" == typeof self && self) || r("object" == typeof e && e) || r("object" == typeof n && n) || function () {
      return this;
    }() || Function("return this")();
  }
  var i,
    a,
    f,
    c,
    l,
    s,
    v,
    p,
    m = {};
  function d() {
    return a ? i : (a = 1, i = function (r) {
      try {
        return !!r();
      } catch (r) {
        return !0;
      }
    });
  }
  function g() {
    if (c) return f;
    c = 1;
    var r = d();
    return f = !r(function () {
      return 7 !== Object.defineProperty({}, 1, {
        get: function () {
          return 7;
        }
      })[1];
    });
  }
  function b() {
    if (s) return l;
    s = 1;
    var r = d();
    return l = !r(function () {
      var r = function () {}.bind();
      return "function" != typeof r || r.hasOwnProperty("prototype");
    });
  }
  function y() {
    if (p) return v;
    p = 1;
    var r = b(),
      n = Function.prototype.call;
    return v = r ? n.bind(n) : function () {
      return n.apply(n, arguments);
    }, v;
  }
  var h,
    w,
    S,
    O,
    j,
    P,
    T,
    E,
    x,
    A,
    C,
    R,
    F,
    M,
    D,
    I,
    L,
    k,
    z,
    N,
    q,
    B,
    _,
    G,
    U,
    W,
    H,
    $,
    J,
    K,
    Q,
    V,
    X,
    Y,
    Z,
    rr,
    nr,
    tr,
    er,
    or,
    ur,
    ir = {};
  function ar() {
    if (h) return ir;
    h = 1;
    var r = {}.propertyIsEnumerable,
      n = Object.getOwnPropertyDescriptor,
      t = n && !r.call({
        1: 2
      }, 1);
    return ir.f = t ? function (r) {
      var t = n(this, r);
      return !!t && t.enumerable;
    } : r, ir;
  }
  function fr() {
    return S ? w : (S = 1, w = function (r, n) {
      return {
        enumerable: !(1 & r),
        configurable: !(2 & r),
        writable: !(4 & r),
        value: n
      };
    });
  }
  function cr() {
    if (j) return O;
    j = 1;
    var r = b(),
      n = Function.prototype,
      t = n.call,
      e = r && n.bind.bind(t, t);
    return O = r ? e : function (r) {
      return function () {
        return t.apply(r, arguments);
      };
    }, O;
  }
  function lr() {
    if (T) return P;
    T = 1;
    var r = cr(),
      n = r({}.toString),
      t = r("".slice);
    return P = function (r) {
      return t(n(r), 8, -1);
    };
  }
  function sr() {
    if (x) return E;
    x = 1;
    var r = cr(),
      n = d(),
      t = lr(),
      e = Object,
      o = r("".split);
    return E = n(function () {
      return !e("z").propertyIsEnumerable(0);
    }) ? function (r) {
      return "String" === t(r) ? o(r, "") : e(r);
    } : e;
  }
  function vr() {
    return C ? A : (C = 1, A = function (r) {
      return null == r;
    });
  }
  function pr() {
    if (F) return R;
    F = 1;
    var r = vr(),
      n = TypeError;
    return R = function (t) {
      if (r(t)) throw new n("Can't call method on " + t);
      return t;
    };
  }
  function mr() {
    if (D) return M;
    D = 1;
    var r = sr(),
      n = pr();
    return M = function (t) {
      return r(n(t));
    };
  }
  function dr() {
    if (L) return I;
    L = 1;
    var r = "object" == typeof document && document.all;
    return I = void 0 === r && void 0 !== r ? function (n) {
      return "function" == typeof n || n === r;
    } : function (r) {
      return "function" == typeof r;
    };
  }
  function gr() {
    if (z) return k;
    z = 1;
    var r = dr();
    return k = function (n) {
      return "object" == typeof n ? null !== n : r(n);
    };
  }
  function br() {
    if (q) return N;
    q = 1;
    var r = u(),
      n = dr();
    return N = function (t, e) {
      return arguments.length < 2 ? (o = r[t], n(o) ? o : void 0) : r[t] && r[t][e];
      var o;
    }, N;
  }
  function yr() {
    if (H) return W;
    H = 1;
    var r,
      n,
      t = u(),
      e = function () {
        if (U) return G;
        U = 1;
        var r = u().navigator,
          n = r && r.userAgent;
        return G = n ? String(n) : "";
      }(),
      o = t.process,
      i = t.Deno,
      a = o && o.versions || i && i.version,
      f = a && a.v8;
    return f && (n = (r = f.split("."))[0] > 0 && r[0] < 4 ? 1 : +(r[0] + r[1])), !n && e && (!(r = e.match(/Edge\/(\d+)/)) || r[1] >= 74) && (r = e.match(/Chrome\/(\d+)/)) && (n = +r[1]), W = n;
  }
  function hr() {
    if (J) return $;
    J = 1;
    var r = yr(),
      n = d(),
      t = u().String;
    return $ = !!Object.getOwnPropertySymbols && !n(function () {
      var n = Symbol("symbol detection");
      return !t(n) || !(Object(n) instanceof Symbol) || !Symbol.sham && r && r < 41;
    });
  }
  function wr() {
    if (Q) return K;
    Q = 1;
    var r = hr();
    return K = r && !Symbol.sham && "symbol" == typeof Symbol.iterator;
  }
  function Sr() {
    if (X) return V;
    X = 1;
    var r = br(),
      n = dr(),
      t = function () {
        if (_) return B;
        _ = 1;
        var r = cr();
        return B = r({}.isPrototypeOf);
      }(),
      e = wr(),
      o = Object;
    return V = e ? function (r) {
      return "symbol" == typeof r;
    } : function (e) {
      var u = r("Symbol");
      return n(u) && t(u.prototype, o(e));
    };
  }
  function Or() {
    if (Z) return Y;
    Z = 1;
    var r = String;
    return Y = function (n) {
      try {
        return r(n);
      } catch (r) {
        return "Object";
      }
    };
  }
  function jr() {
    if (nr) return rr;
    nr = 1;
    var r = dr(),
      n = Or(),
      t = TypeError;
    return rr = function (e) {
      if (r(e)) return e;
      throw new t(n(e) + " is not a function");
    };
  }
  function Pr() {
    if (er) return tr;
    er = 1;
    var r = jr(),
      n = vr();
    return tr = function (t, e) {
      var o = t[e];
      return n(o) ? void 0 : r(o);
    };
  }
  function Tr() {
    if (ur) return or;
    ur = 1;
    var r = y(),
      n = dr(),
      t = gr(),
      e = TypeError;
    return or = function (o, u) {
      var i, a;
      if ("string" === u && n(i = o.toString) && !t(a = r(i, o))) return a;
      if (n(i = o.valueOf) && !t(a = r(i, o))) return a;
      if ("string" !== u && n(i = o.toString) && !t(a = r(i, o))) return a;
      throw new e("Can't convert object to primitive value");
    };
  }
  var Er,
    xr,
    Ar,
    Cr,
    Rr,
    Fr,
    Mr,
    Dr,
    Ir,
    Lr,
    kr,
    zr,
    Nr,
    qr,
    Br,
    _r,
    Gr,
    Ur,
    Wr,
    Hr,
    $r,
    Jr,
    Kr,
    Qr,
    Vr = {
      exports: {}
    };
  function Xr() {
    if (Cr) return Ar;
    Cr = 1;
    var r = u(),
      n = Object.defineProperty;
    return Ar = function (t, e) {
      try {
        n(r, t, {
          value: e,
          configurable: !0,
          writable: !0
        });
      } catch (n) {
        r[t] = e;
      }
      return e;
    };
  }
  function Yr() {
    if (Rr) return Vr.exports;
    Rr = 1;
    var r = xr ? Er : (xr = 1, Er = !1),
      n = u(),
      t = Xr(),
      e = "__core-js_shared__",
      o = Vr.exports = n[e] || t(e, {});
    return (o.versions || (o.versions = [])).push({
      version: "3.39.0",
      mode: r ? "pure" : "global",
      copyright: "© 2014-2024 Denis Pushkarev (zloirock.ru)",
      license: "https://github.com/zloirock/core-js/blob/v3.39.0/LICENSE",
      source: "https://github.com/zloirock/core-js"
    }), Vr.exports;
  }
  function Zr() {
    if (Mr) return Fr;
    Mr = 1;
    var r = Yr();
    return Fr = function (n, t) {
      return r[n] || (r[n] = t || {});
    };
  }
  function rn() {
    if (Ir) return Dr;
    Ir = 1;
    var r = pr(),
      n = Object;
    return Dr = function (t) {
      return n(r(t));
    };
  }
  function nn() {
    if (kr) return Lr;
    kr = 1;
    var r = cr(),
      n = rn(),
      t = r({}.hasOwnProperty);
    return Lr = Object.hasOwn || function (r, e) {
      return t(n(r), e);
    };
  }
  function tn() {
    if (Nr) return zr;
    Nr = 1;
    var r = cr(),
      n = 0,
      t = Math.random(),
      e = r(1..toString);
    return zr = function (r) {
      return "Symbol(" + (void 0 === r ? "" : r) + ")_" + e(++n + t, 36);
    };
  }
  function en() {
    if (Br) return qr;
    Br = 1;
    var r = u(),
      n = Zr(),
      t = nn(),
      e = tn(),
      o = hr(),
      i = wr(),
      a = r.Symbol,
      f = n("wks"),
      c = i ? a.for || a : a && a.withoutSetter || e;
    return qr = function (r) {
      return t(f, r) || (f[r] = o && t(a, r) ? a[r] : c("Symbol." + r)), f[r];
    };
  }
  function on() {
    if (Gr) return _r;
    Gr = 1;
    var r = y(),
      n = gr(),
      t = Sr(),
      e = Pr(),
      o = Tr(),
      u = en(),
      i = TypeError,
      a = u("toPrimitive");
    return _r = function (u, f) {
      if (!n(u) || t(u)) return u;
      var c,
        l = e(u, a);
      if (l) {
        if (void 0 === f && (f = "default"), c = r(l, u, f), !n(c) || t(c)) return c;
        throw new i("Can't convert object to primitive value");
      }
      return void 0 === f && (f = "number"), o(u, f);
    };
  }
  function un() {
    if (Wr) return Ur;
    Wr = 1;
    var r = on(),
      n = Sr();
    return Ur = function (t) {
      var e = r(t, "string");
      return n(e) ? e : e + "";
    };
  }
  function an() {
    if (Kr) return Jr;
    Kr = 1;
    var r = g(),
      n = d(),
      t = function () {
        if ($r) return Hr;
        $r = 1;
        var r = u(),
          n = gr(),
          t = r.document,
          e = n(t) && n(t.createElement);
        return Hr = function (r) {
          return e ? t.createElement(r) : {};
        };
      }();
    return Jr = !r && !n(function () {
      return 7 !== Object.defineProperty(t("div"), "a", {
        get: function () {
          return 7;
        }
      }).a;
    });
  }
  function fn() {
    if (Qr) return m;
    Qr = 1;
    var r = g(),
      n = y(),
      t = ar(),
      e = fr(),
      o = mr(),
      u = un(),
      i = nn(),
      a = an(),
      f = Object.getOwnPropertyDescriptor;
    return m.f = r ? f : function (r, c) {
      if (r = o(r), c = u(c), a) try {
        return f(r, c);
      } catch (r) {}
      if (i(r, c)) return e(!n(t.f, r, c), r[c]);
    }, m;
  }
  var cn,
    ln,
    sn,
    vn,
    pn,
    mn,
    dn,
    gn = {};
  function bn() {
    if (vn) return sn;
    vn = 1;
    var r = gr(),
      n = String,
      t = TypeError;
    return sn = function (e) {
      if (r(e)) return e;
      throw new t(n(e) + " is not an object");
    };
  }
  function yn() {
    if (pn) return gn;
    pn = 1;
    var r = g(),
      n = an(),
      t = function () {
        if (ln) return cn;
        ln = 1;
        var r = g(),
          n = d();
        return cn = r && n(function () {
          return 42 !== Object.defineProperty(function () {}, "prototype", {
            value: 42,
            writable: !1
          }).prototype;
        });
      }(),
      e = bn(),
      o = un(),
      u = TypeError,
      i = Object.defineProperty,
      a = Object.getOwnPropertyDescriptor,
      f = "enumerable",
      c = "configurable",
      l = "writable";
    return gn.f = r ? t ? function (r, n, t) {
      if (e(r), n = o(n), e(t), "function" == typeof r && "prototype" === n && "value" in t && l in t && !t[l]) {
        var u = a(r, n);
        u && u[l] && (r[n] = t.value, t = {
          configurable: c in t ? t[c] : u[c],
          enumerable: f in t ? t[f] : u[f],
          writable: !1
        });
      }
      return i(r, n, t);
    } : i : function (r, t, a) {
      if (e(r), t = o(t), e(a), n) try {
        return i(r, t, a);
      } catch (r) {}
      if ("get" in a || "set" in a) throw new u("Accessors not supported");
      return "value" in a && (r[t] = a.value), r;
    }, gn;
  }
  function hn() {
    if (dn) return mn;
    dn = 1;
    var r = g(),
      n = yn(),
      t = fr();
    return mn = r ? function (r, e, o) {
      return n.f(r, e, t(1, o));
    } : function (r, n, t) {
      return r[n] = t, r;
    };
  }
  var wn,
    Sn,
    On,
    jn,
    Pn,
    Tn,
    En,
    xn,
    An,
    Cn,
    Rn,
    Fn,
    Mn,
    Dn,
    In,
    Ln = {
      exports: {}
    };
  function kn() {
    if (jn) return On;
    jn = 1;
    var r = cr(),
      n = dr(),
      t = Yr(),
      e = r(Function.toString);
    return n(t.inspectSource) || (t.inspectSource = function (r) {
      return e(r);
    }), On = t.inspectSource;
  }
  function zn() {
    if (xn) return En;
    xn = 1;
    var r = Zr(),
      n = tn(),
      t = r("keys");
    return En = function (r) {
      return t[r] || (t[r] = n(r));
    };
  }
  function Nn() {
    return Cn ? An : (Cn = 1, An = {});
  }
  function qn() {
    if (Fn) return Rn;
    Fn = 1;
    var r,
      n,
      t,
      e = function () {
        if (Tn) return Pn;
        Tn = 1;
        var r = u(),
          n = dr(),
          t = r.WeakMap;
        return Pn = n(t) && /native code/.test(String(t));
      }(),
      o = u(),
      i = gr(),
      a = hn(),
      f = nn(),
      c = Yr(),
      l = zn(),
      s = Nn(),
      v = "Object already initialized",
      p = o.TypeError,
      m = o.WeakMap;
    if (e || c.state) {
      var d = c.state || (c.state = new m());
      d.get = d.get, d.has = d.has, d.set = d.set, r = function (r, n) {
        if (d.has(r)) throw new p(v);
        return n.facade = r, d.set(r, n), n;
      }, n = function (r) {
        return d.get(r) || {};
      }, t = function (r) {
        return d.has(r);
      };
    } else {
      var g = l("state");
      s[g] = !0, r = function (r, n) {
        if (f(r, g)) throw new p(v);
        return n.facade = r, a(r, g, n), n;
      }, n = function (r) {
        return f(r, g) ? r[g] : {};
      }, t = function (r) {
        return f(r, g);
      };
    }
    return Rn = {
      set: r,
      get: n,
      has: t,
      enforce: function (e) {
        return t(e) ? n(e) : r(e, {});
      },
      getterFor: function (r) {
        return function (t) {
          var e;
          if (!i(t) || (e = n(t)).type !== r) throw new p("Incompatible receiver, " + r + " required");
          return e;
        };
      }
    };
  }
  function Bn() {
    if (Mn) return Ln.exports;
    Mn = 1;
    var r = cr(),
      n = d(),
      t = dr(),
      e = nn(),
      o = g(),
      u = function () {
        if (Sn) return wn;
        Sn = 1;
        var r = g(),
          n = nn(),
          t = Function.prototype,
          e = r && Object.getOwnPropertyDescriptor,
          o = n(t, "name"),
          u = o && "something" === function () {}.name,
          i = o && (!r || r && e(t, "name").configurable);
        return wn = {
          EXISTS: o,
          PROPER: u,
          CONFIGURABLE: i
        };
      }().CONFIGURABLE,
      i = kn(),
      a = qn(),
      f = a.enforce,
      c = a.get,
      l = String,
      s = Object.defineProperty,
      v = r("".slice),
      p = r("".replace),
      m = r([].join),
      b = o && !n(function () {
        return 8 !== s(function () {}, "length", {
          value: 8
        }).length;
      }),
      y = String(String).split("String"),
      h = Ln.exports = function (r, n, t) {
        "Symbol(" === v(l(n), 0, 7) && (n = "[" + p(l(n), /^Symbol\(([^)]*)\).*$/, "$1") + "]"), t && t.getter && (n = "get " + n), t && t.setter && (n = "set " + n), (!e(r, "name") || u && r.name !== n) && (o ? s(r, "name", {
          value: n,
          configurable: !0
        }) : r.name = n), b && t && e(t, "arity") && r.length !== t.arity && s(r, "length", {
          value: t.arity
        });
        try {
          t && e(t, "constructor") && t.constructor ? o && s(r, "prototype", {
            writable: !1
          }) : r.prototype && (r.prototype = void 0);
        } catch (r) {}
        var i = f(r);
        return e(i, "source") || (i.source = m(y, "string" == typeof n ? n : "")), r;
      };
    return Function.prototype.toString = h(function () {
      return t(this) && c(this).source || i(this);
    }, "toString"), Ln.exports;
  }
  function _n() {
    if (In) return Dn;
    In = 1;
    var r = dr(),
      n = yn(),
      t = Bn(),
      e = Xr();
    return Dn = function (o, u, i, a) {
      a || (a = {});
      var f = a.enumerable,
        c = void 0 !== a.name ? a.name : u;
      if (r(i) && t(i, c, a), a.global) f ? o[u] = i : e(u, i);else {
        try {
          a.unsafe ? o[u] && (f = !0) : delete o[u];
        } catch (r) {}
        f ? o[u] = i : n.f(o, u, {
          value: i,
          enumerable: !1,
          configurable: !a.nonConfigurable,
          writable: !a.nonWritable
        });
      }
      return o;
    };
  }
  var Gn,
    Un,
    Wn,
    Hn,
    $n,
    Jn,
    Kn,
    Qn,
    Vn,
    Xn,
    Yn,
    Zn,
    rt,
    nt,
    tt,
    et,
    ot,
    ut = {};
  function it() {
    if (Hn) return Wn;
    Hn = 1;
    var r = function () {
      if (Un) return Gn;
      Un = 1;
      var r = Math.ceil,
        n = Math.floor;
      return Gn = Math.trunc || function (t) {
        var e = +t;
        return (e > 0 ? n : r)(e);
      };
    }();
    return Wn = function (n) {
      var t = +n;
      return t != t || 0 === t ? 0 : r(t);
    };
  }
  function at() {
    if (Jn) return $n;
    Jn = 1;
    var r = it(),
      n = Math.max,
      t = Math.min;
    return $n = function (e, o) {
      var u = r(e);
      return u < 0 ? n(u + o, 0) : t(u, o);
    };
  }
  function ft() {
    if (Qn) return Kn;
    Qn = 1;
    var r = it(),
      n = Math.min;
    return Kn = function (t) {
      var e = r(t);
      return e > 0 ? n(e, 9007199254740991) : 0;
    };
  }
  function ct() {
    if (Xn) return Vn;
    Xn = 1;
    var r = ft();
    return Vn = function (n) {
      return r(n.length);
    };
  }
  function lt() {
    if (nt) return rt;
    nt = 1;
    var r = cr(),
      n = nn(),
      t = mr(),
      e = function () {
        if (Zn) return Yn;
        Zn = 1;
        var r = mr(),
          n = at(),
          t = ct(),
          e = function (e) {
            return function (o, u, i) {
              var a = r(o),
                f = t(a);
              if (0 === f) return !e && -1;
              var c,
                l = n(i, f);
              if (e && u != u) {
                for (; f > l;) if ((c = a[l++]) != c) return !0;
              } else for (; f > l; l++) if ((e || l in a) && a[l] === u) return e || l || 0;
              return !e && -1;
            };
          };
        return Yn = {
          includes: e(!0),
          indexOf: e(!1)
        };
      }().indexOf,
      o = Nn(),
      u = r([].push);
    return rt = function (r, i) {
      var a,
        f = t(r),
        c = 0,
        l = [];
      for (a in f) !n(o, a) && n(f, a) && u(l, a);
      for (; i.length > c;) n(f, a = i[c++]) && (~e(l, a) || u(l, a));
      return l;
    };
  }
  function st() {
    return et ? tt : (et = 1, tt = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"]);
  }
  var vt,
    pt,
    mt,
    dt,
    gt,
    bt,
    yt,
    ht,
    wt,
    St,
    Ot,
    jt,
    Pt,
    Tt,
    Et,
    xt,
    At,
    Ct,
    Rt,
    Ft,
    Mt,
    Dt,
    It,
    Lt,
    kt,
    zt,
    Nt,
    qt,
    Bt = {};
  function _t() {
    return vt || (vt = 1, Bt.f = Object.getOwnPropertySymbols), Bt;
  }
  function Gt() {
    if (mt) return pt;
    mt = 1;
    var r = br(),
      n = cr(),
      t = function () {
        if (ot) return ut;
        ot = 1;
        var r = lt(),
          n = st().concat("length", "prototype");
        return ut.f = Object.getOwnPropertyNames || function (t) {
          return r(t, n);
        }, ut;
      }(),
      e = _t(),
      o = bn(),
      u = n([].concat);
    return pt = r("Reflect", "ownKeys") || function (r) {
      var n = t.f(o(r)),
        i = e.f;
      return i ? u(n, i(r)) : n;
    };
  }
  function Ut() {
    if (gt) return dt;
    gt = 1;
    var r = nn(),
      n = Gt(),
      t = fn(),
      e = yn();
    return dt = function (o, u, i) {
      for (var a = n(u), f = e.f, c = t.f, l = 0; l < a.length; l++) {
        var s = a[l];
        r(o, s) || i && r(i, s) || f(o, s, c(u, s));
      }
    };
  }
  function Wt() {
    if (wt) return ht;
    wt = 1;
    var r = u(),
      n = fn().f,
      t = hn(),
      e = _n(),
      o = Xr(),
      i = Ut(),
      a = function () {
        if (yt) return bt;
        yt = 1;
        var r = d(),
          n = dr(),
          t = /#|\.prototype\./,
          e = function (t, e) {
            var f = u[o(t)];
            return f === a || f !== i && (n(e) ? r(e) : !!e);
          },
          o = e.normalize = function (r) {
            return String(r).replace(t, ".").toLowerCase();
          },
          u = e.data = {},
          i = e.NATIVE = "N",
          a = e.POLYFILL = "P";
        return bt = e;
      }();
    return ht = function (u, f) {
      var c,
        l,
        s,
        v,
        p,
        m = u.target,
        d = u.global,
        g = u.stat;
      if (c = d ? r : g ? r[m] || o(m, {}) : r[m] && r[m].prototype) for (l in f) {
        if (v = f[l], s = u.dontCallGetSet ? (p = n(c, l)) && p.value : c[l], !a(d ? l : m + (g ? "." : "#") + l, u.forced) && void 0 !== s) {
          if (typeof v == typeof s) continue;
          i(v, s);
        }
        (u.sham || s && s.sham) && t(v, "sham", !0), e(c, l, v, u);
      }
    };
  }
  function Ht() {
    if (Ot) return St;
    Ot = 1;
    var r = lr();
    return St = Array.isArray || function (n) {
      return "Array" === r(n);
    };
  }
  function $t() {
    if (Pt) return jt;
    Pt = 1;
    var r = TypeError;
    return jt = function (n) {
      if (n > 9007199254740991) throw r("Maximum allowed index exceeded");
      return n;
    };
  }
  function Jt() {
    if (Et) return Tt;
    Et = 1;
    var r = g(),
      n = yn(),
      t = fr();
    return Tt = function (e, o, u) {
      r ? n.f(e, o, t(0, u)) : e[o] = u;
    };
  }
  function Kt() {
    if (Rt) return Ct;
    Rt = 1;
    var r = function () {
        if (At) return xt;
        At = 1;
        var r = {};
        return r[en()("toStringTag")] = "z", xt = "[object z]" === String(r);
      }(),
      n = dr(),
      t = lr(),
      e = en()("toStringTag"),
      o = Object,
      u = "Arguments" === t(function () {
        return arguments;
      }());
    return Ct = r ? t : function (r) {
      var i, a, f;
      return void 0 === r ? "Undefined" : null === r ? "Null" : "string" == typeof (a = function (r, n) {
        try {
          return r[n];
        } catch (r) {}
      }(i = o(r), e)) ? a : u ? t(i) : "Object" === (f = t(i)) && n(i.callee) ? "Arguments" : f;
    };
  }
  function Qt() {
    if (Mt) return Ft;
    Mt = 1;
    var r = cr(),
      n = d(),
      t = dr(),
      e = Kt(),
      o = br(),
      u = kn(),
      i = function () {},
      a = o("Reflect", "construct"),
      f = /^\s*(?:class|function)\b/,
      c = r(f.exec),
      l = !f.test(i),
      s = function (r) {
        if (!t(r)) return !1;
        try {
          return a(i, [], r), !0;
        } catch (r) {
          return !1;
        }
      },
      v = function (r) {
        if (!t(r)) return !1;
        switch (e(r)) {
          case "AsyncFunction":
          case "GeneratorFunction":
          case "AsyncGeneratorFunction":
            return !1;
        }
        try {
          return l || !!c(f, u(r));
        } catch (r) {
          return !0;
        }
      };
    return v.sham = !0, Ft = !a || n(function () {
      var r;
      return s(s.call) || !s(Object) || !s(function () {
        r = !0;
      }) || r;
    }) ? v : s;
  }
  function Vt() {
    if (It) return Dt;
    It = 1;
    var r = Ht(),
      n = Qt(),
      t = gr(),
      e = en()("species"),
      o = Array;
    return Dt = function (u) {
      var i;
      return r(u) && (i = u.constructor, (n(i) && (i === o || r(i.prototype)) || t(i) && null === (i = i[e])) && (i = void 0)), void 0 === i ? o : i;
    };
  }
  function Xt() {
    if (kt) return Lt;
    kt = 1;
    var r = Vt();
    return Lt = function (n, t) {
      return new (r(n))(0 === t ? 0 : t);
    };
  }
  function Yt() {
    if (Nt) return zt;
    Nt = 1;
    var r = d(),
      n = en(),
      t = yr(),
      e = n("species");
    return zt = function (n) {
      return t >= 51 || !r(function () {
        var r = [];
        return (r.constructor = {})[e] = function () {
          return {
            foo: 1
          };
        }, 1 !== r[n](Boolean).foo;
      });
    };
  }
  !function () {
    if (qt) return o;
    qt = 1;
    var r = Wt(),
      n = d(),
      t = Ht(),
      e = gr(),
      u = rn(),
      i = ct(),
      a = $t(),
      f = Jt(),
      c = Xt(),
      l = Yt(),
      s = en(),
      v = yr(),
      p = s("isConcatSpreadable"),
      m = v >= 51 || !n(function () {
        var r = [];
        return r[p] = !1, r.concat()[0] !== r;
      }),
      g = function (r) {
        if (!e(r)) return !1;
        var n = r[p];
        return void 0 !== n ? !!n : t(r);
      };
    r({
      target: "Array",
      proto: !0,
      arity: 1,
      forced: !m || !l("concat")
    }, {
      concat: function (r) {
        var n,
          t,
          e,
          o,
          l,
          s = u(this),
          v = c(s, 0),
          p = 0;
        for (n = -1, e = arguments.length; n < e; n++) if (g(l = -1 === n ? s : arguments[n])) for (o = i(l), a(p + o), t = 0; t < o; t++, p++) t in l && f(v, p, l[t]);else a(p + 1), f(v, p++, l);
        return v.length = p, v;
      }
    });
  }();
  var Zt,
    re,
    ne,
    te,
    ee,
    oe = {};
  function ue() {
    if (re) return Zt;
    re = 1;
    var r = lt(),
      n = st();
    return Zt = Object.keys || function (t) {
      return r(t, n);
    };
  }
  !function () {
    if (ee) return oe;
    ee = 1;
    var r = Wt(),
      n = function () {
        if (te) return ne;
        te = 1;
        var r = g(),
          n = cr(),
          t = y(),
          e = d(),
          o = ue(),
          u = _t(),
          i = ar(),
          a = rn(),
          f = sr(),
          c = Object.assign,
          l = Object.defineProperty,
          s = n([].concat);
        return ne = !c || e(function () {
          if (r && 1 !== c({
            b: 1
          }, c(l({}, "a", {
            enumerable: !0,
            get: function () {
              l(this, "b", {
                value: 3,
                enumerable: !1
              });
            }
          }), {
            b: 2
          })).b) return !0;
          var n = {},
            t = {},
            e = Symbol("assign detection"),
            u = "abcdefghijklmnopqrst";
          return n[e] = 7, u.split("").forEach(function (r) {
            t[r] = r;
          }), 7 !== c({}, n)[e] || o(c({}, t)).join("") !== u;
        }) ? function (n, e) {
          for (var c = a(n), l = arguments.length, v = 1, p = u.f, m = i.f; l > v;) for (var d, g = f(arguments[v++]), b = p ? s(o(g), p(g)) : o(g), y = b.length, h = 0; y > h;) d = b[h++], r && !t(m, g, d) || (c[d] = g[d]);
          return c;
        } : c, ne;
      }();
    r({
      target: "Object",
      stat: !0,
      arity: 2,
      forced: Object.assign !== n
    }, {
      assign: n
    });
  }(), r.fn.bootstrapTable.locales["pt-BR"] = r.fn.bootstrapTable.locales.br = {
    formatCopyRows: function () {
      return "Copiar linhas";
    },
    formatPrint: function () {
      return "Imprimir";
    },
    formatLoadingMessage: function () {
      return "Carregando, aguarde";
    },
    formatRecordsPerPage: function (r) {
      return "".concat(r, " registros por página");
    },
    formatShowingRows: function (r, n, t, e) {
      var o = t > 1 ? "s" : "";
      return void 0 !== e && e > 0 && e > t ? "Exibindo ".concat(r, " até ").concat(n, " de ").concat(t, " linha").concat(o, " (filtrado de um total de ").concat(e, " linha").concat(o, ")") : "Exibindo ".concat(r, " até ").concat(n, " de ").concat(t, " linha").concat(o);
    },
    formatSRPaginationPreText: function () {
      return "página anterior";
    },
    formatSRPaginationPageText: function (r) {
      return "ir para a página ".concat(r);
    },
    formatSRPaginationNextText: function () {
      return "próxima página";
    },
    formatDetailPagination: function (r) {
      return "Mostrando ".concat(r, " linha").concat(r > 1 ? "s" : "");
    },
    formatClearSearch: function () {
      return "Limpar Pesquisa";
    },
    formatSearch: function () {
      return "Pesquisar";
    },
    formatNoMatches: function () {
      return "Nenhum registro encontrado";
    },
    formatPaginationSwitch: function () {
      return "Ocultar/Exibir paginação";
    },
    formatPaginationSwitchDown: function () {
      return "Mostrar Paginação";
    },
    formatPaginationSwitchUp: function () {
      return "Esconder Paginação";
    },
    formatRefresh: function () {
      return "Recarregar";
    },
    formatToggleOn: function () {
      return "Mostrar visualização de cartão";
    },
    formatToggleOff: function () {
      return "Hide card view";
    },
    formatColumns: function () {
      return "Colunas";
    },
    formatColumnsToggleAll: function () {
      return "Alternar tudo";
    },
    formatFullscreen: function () {
      return "Tela cheia";
    },
    formatAllRows: function () {
      return "Tudo";
    },
    formatAutoRefresh: function () {
      return "Atualização Automática";
    },
    formatExport: function () {
      return "Exportar dados";
    },
    formatJumpTo: function () {
      return "Ir";
    },
    formatAdvancedSearch: function () {
      return "Pesquisa Avançada";
    },
    formatAdvancedCloseButton: function () {
      return "Fechar";
    },
    formatFilterControlSwitch: function () {
      return "Ocultar/Exibir controles";
    },
    formatFilterControlSwitchHide: function () {
      return "Ocultar controles";
    },
    formatFilterControlSwitchShow: function () {
      return "Exibir controles";
    },
    formatAddLevel: function () {
      return "Adicionar nível";
    },
    formatCancel: function () {
      return "Cancelar";
    },
    formatColumn: function () {
      return "Coluna";
    },
    formatDeleteLevel: function () {
      return "Remover nível";
    },
    formatDuplicateAlertTitle: function () {
      return "Encontradas entradas duplicadas!";
    },
    formatDuplicateAlertDescription: function () {
      return "Por favor, remova ou altere as colunas duplicadas";
    },
    formatMultipleSort: function () {
      return "Ordenação múltipla";
    },
    formatOrder: function () {
      return "Ordem";
    },
    formatSort: function () {
      return "Ordenar";
    },
    formatSortBy: function () {
      return "Ordenar por";
    },
    formatThenBy: function () {
      return "em seguida";
    },
    formatSortOrders: function () {
      return {
        asc: "Crescente",
        desc: "Decrescente"
      };
    }
  }, Object.assign(r.fn.bootstrapTable.defaults, r.fn.bootstrapTable.locales["pt-BR"]);
});